import React, { CSSProperties as css } from 'react';
import StandardTile from '../../../general/StandardTile';

const localTileStyle: css = {
  margin: 3,
  marginBottom: 6,
};
const LocalPersonTile = ({
  style = {},
  title = '',
  children,
  action,
  collapsible = false,
  initialCollapsed = false,
  loading = false,
}) => (
  <StandardTile
    style={{ ...style, ...localTileStyle }}
    title={title}
    action={action}
    collapsible={collapsible}
    initialCollapse={initialCollapsed}
    loading={loading}
  >
    {children}
  </StandardTile>
);

export default LocalPersonTile;
